<template>
  <q-card flat
          :style="isDialog && $q.screen.lt.md || isCompactView?(!$q.screen.lt.md?'width: 500px;':''):'width:100vw'">
    <q-card-section class="no-padding">
      <q-input v-model="filter"
               filled
               autofocus
               label="جستجو در گروه کالاها"
      >
        <template v-slot:append>
          <q-btn class="q-mr-xs"
                 round
                 flat
                 color="indigo"
                 icon="print"
                 size="lg"
                 v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v))"
                 @click="showGroupPrintDialog()">
            <q-tooltip>
              چاپ گزارشات مربوط به کلیه گروه های کالایی
            </q-tooltip>
          </q-btn>
        </template>
      </q-input>
    </q-card-section>
    <q-card-section class="no-padding" v-if="customerInfo">
      <q-toggle v-model="selectedSaleList" label="گروه کالاهایی که خرید نموده"/>
      <q-space/>
      <q-toggle v-model="selectedUnSaleList" label="گروه کالاهایی که خرید ننموده"/>
      <q-space/>
      <q-toggle v-model="selectedAll" label="همه گروه ها"/>
      <q-separator spaced/>
    </q-card-section>
    <q-card-section class="no-padding q-ml-sm">
      <q-btn round
             flat
             icon="add_circle"
             padding="none"
             size="lg"
             color="indigo"
             @click="showGoodsGroupCuDialog({Group_ID:undefined,Group_Name:undefined})"
             v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
        <q-tooltip>
          افزودن گروه جدید
        </q-tooltip>
      </q-btn>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          flat
          :data="items"
          row-key="Group_ID"
          :wrap-cells="$q.screen.lt.md || isCompactView"
          :pagination="pagination"
          :filter="filter"
          :hide-header="$q.screen.lt.md || isCompactView"
          :columns="columns">
        <template v-slot:body="props">
          <q-tr :props="props" v-if="$q.screen.lt.md || isCompactView">
            <q-td>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     @click="showGoodsGroupCuDialog(props.row)"
                     icon="edit"
                     padding="none"
                     color="blue-grey-14"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
                <q-tooltip>
                  ویرایش
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="delete"
                     padding="none"
                     color="red"
                     @click="deleteGoodsGroup(props.row)"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
                <q-tooltip>
                  حذف
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="pan_tool"
                     padding="none"
                     color="blue-grey-14"
                     @click="showGoodsStateDialog(props.row)"
                     v-if="$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))">
                <q-tooltip>
                  تغییر وضعیت فروش کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
                     round
                     flat
                     icon="person_off"
                     padding="none"
                     :color="props.row.Goods_Group?'blue-grey-14':'green'"
                     @click="showCustomerNoWorking(props.row)">
                <q-tooltip>
                  {{
                    customerInfo ? props.row.Goods_Group ? 'قبلا خرید داشته است' : 'تاکنون خرید نداشته است' : 'لیست طرف معامله‌ که این گروه کالا را کار ننموده اند'
                  }}
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="person"
                     padding="none"
                     :color="props.row.Goods_Group?'blue-grey-14':'green'"
                     v-if="!customerInfo && $store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
                     @click="showCustomerWorking(props.row)">
                <q-tooltip>
                  لیست طرف معاملهی که این گروه کالا را خریداری نموده اند
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="bar_chart"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','can_see_yearly_report'].includes(v))"
                     @click="showGoodsGroupDashBoard(props.row)">
                <q-tooltip>
                  داشبورد فروش گروه کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="attach_money"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))"
                     @click="showGoodsGroupPrice(props.row)">
                <q-tooltip>
                  تغییر قیمت گروه کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="print"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','user_sell','user_purchase','salemanager'].includes(v))"
                     @click="showPrintDialog(props.row)">
                <q-tooltip>
                  چاپ
                </q-tooltip>
              </q-btn>
              <q-space/>
              <q-chip square :label="props.row.Group_Name" clickable v-close-popup
                      @click="$emit('group-selected', props.row)">
                <q-badge class="q-ml-xs" :color="props.row.Goods_Stock>0?'green-10':'red-10'"
                         text-color="white"
                         :label="props.row.Goods_Stock"/>
              </q-chip>
              <q-chip square :color="props.row.TransactionCount>=70?'green-10':'deep-orange-10'"
                      text-color="white"
                      icon="speed"
                      size="sm"
                      :label="props.row.TransactionCount>=70?'تند فروش':'کند فروش'"/>
              <q-space/>
              <q-chip square
                      label="سود فروش"
                      v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v)) && props.row.DiffPay">
                <q-badge dir="ltr" align="top" :color="props.row.DiffPay>0?'green':'red'"
                         :label="props.row.DiffPay.toLocaleString()"/>
              </q-chip>
              <q-chip square
                      label="درصد اختلاف خرید و فروش"
                      v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v)) && props.row.DiffPay">
                <q-badge dir="ltr" align="top" :color="props.row.DiffPay>0?'green':'red'"
                         :label="props.row.Profit" class="q-ml-xs"/>
              </q-chip>
            </q-td>
          </q-tr>
          <q-tr :props="props" v-if="!$q.screen.lt.mdc && !isCompactView">
            <q-td key="Group_Name"
                  @click="$emit('group-selected', props.row)"
                  v-close-popup
                  class="text-left text-bold"
                  :props="props">
              {{ props.row.Group_Name }}
            </q-td>
            <q-td key="Goods_Stock" :prop="props" class="text-center text-bold">
              <span :style="props.row.Goods_Stock>0?'color:green':'color:red'">{{ props.row.Goods_Stock }}</span>
            </q-td>
            <q-td key="Goods_Type" class="text-bold text-center">
                      <span :style="props.row.Goods_Stock>0?'color:green':'color:red'">
                        {{ props.row.TransactionCount >= 70 ? 'تند فروش' : 'کند فروش' }}
                      </span>
            </q-td>
            <q-td key="DiffPay" class="text-bold" :props="props">
              {{
                $store.state.roles.some(v => ['admin', 'can_sea_goods_profit'].includes(v)) ? (props.row.DiffPay ? props.row.DiffPay.toLocaleString() : 0) : 0
              }}
            </q-td>
            <q-td key="Profit" class="text-bold" style="color: darkslategrey" :props="props">
              {{
                $store.state.roles.some(v => ['admin', 'see_profit'].includes(v)) ? (props.row.Profit ? props.row.Profit.toLocaleString() : 0) : 0
              }}
            </q-td>
            <q-td>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     @click="showGoodsGroupCuDialog(props.row)"
                     icon="edit"
                     padding="none"
                     color="blue-grey-14"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
                <q-tooltip>
                  ویرایش
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="delete"
                     padding="none"
                     color="red"
                     @click="deleteGoodsGroup(props.row)"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))">
                <q-tooltip>
                  حذف
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="pan_tool"
                     padding="none"
                     color="blue-grey-14"
                     @click="showGoodsStateDialog(props.row)"
                     v-if="$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))">
                <q-tooltip>
                  تغییر وضعیت فروش کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
                     round
                     flat
                     icon="person_off"
                     padding="none"
                     :color="props.row.Goods_Group?'blue-grey-14':'green'"
                     @click="showCustomerNoWorking(props.row)">
                <q-tooltip>
                  {{
                    customerInfo ? props.row.Goods_Group ? 'قبلا خرید داشته است' : 'تاکنون خرید نداشته است' : 'لیست طرف معامله‌ که این گروه کالا را کار ننموده اند'
                  }}
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="person"
                     padding="none"
                     :color="props.row.Goods_Group?'blue-grey-14':'green'"
                     v-if="!customerInfo && $store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
                     @click="showCustomerWorking(props.row)">
                <q-tooltip>
                  لیست طرف معاملهی که این گروه کالا را خریداری نموده اند
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="bar_chart"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','can_see_yearly_report'].includes(v))"
                     @click="showGoodsGroupDashBoard(props.row)">
                <q-tooltip>
                  داشبورد فروش گروه کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="attach_money"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','can_manage_goods_group'].includes(v))"
                     @click="showGoodsGroupPrice(props.row)">
                <q-tooltip>
                  تغییر قیمت گروه کالا
                </q-tooltip>
              </q-btn>
              <q-btn class="q-mt-xs"
                     round
                     flat
                     icon="print"
                     padding="none"
                     size="lg"
                     :color="'blue-grey-14'"
                     v-if="$store.state.roles.some(v=>['admin','user_sell','user_purchase','salemanager'].includes(v))"
                     @click="showPrintDialog(props.row)">
                <q-tooltip>
                  چاپ
                </q-tooltip>
              </q-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsStateDialog">
      <ChangeState :goods-info="null" :group-info="selectedGroup" @close-dialog="changedGoodsState"/>
    </q-dialog>
    <q-dialog maximized v-model="customerDialog">
      <CustomersList :items="customerList" :is-dialog="true"
                     :is-only-search-list="true"
                     :title="customerListDialogTitle"/>
    </q-dialog>
    <q-dialog v-model="goodsGroupCUDialog" :maximized="$q.screen.lt.md">
      <GoodsGroup :goods-group-info="selectedGroup" @changed-goods-group="changedGoodsGroup"/>
    </q-dialog>

    <q-dialog v-model="productGoodsGroupDashboard" maximized>
      <YearDashboard :goods-group-info="selectedGroup" :is-dialog="true"/>
    </q-dialog>
    <q-dialog v-model="goodsGroupPriceDialog" :maximized="$q.screen.lt.md">
      <GoodsGroupPrice :group-info="selectedGroup" @close-dialog="goodsGroupPriceDialog=false"/>
    </q-dialog>

    <q-dialog v-model="printDialog" :maximized="$q.screen.lt.md">
      <PrintList title="گروه محصولات" :print-list="printList" @report-selected="loadReport"/>
    </q-dialog>

    <q-dialog v-model="printGroupDialog" :maximized="$q.screen.lt.md">
      <PrintList title="گروه محصولات" :print-list="printGroupList" @report-selected="loadGroupReport"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ChangeState from "@/components/products/ChangeState";
import CustomersList from "@/components/customers/CustomersList";
import GoodsGroup from "@/components/GoodsGroup/GoodsGroup";
import GoodsGroupPrice from "@/components/GoodsGroup/GoodsGroupPrice.vue";
import PrintList from "@/components/generals/PrintList.vue";

export default {
  name: "GroupList",
  components: {
    'YearDashboard' :()=>import("@/components/dashboard/SaleYearlyDashboard.vue"),
    PrintList,
    GoodsGroupPrice,
    GoodsGroup,
    CustomersList,
    ChangeState},
  props: {
    customerInfo: {
      type: Object,
      required: false
    },
    isDialog: {
      type: Boolean,
      required: false,
      default: true
    },
    isCompactView: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      printDialog: false,
      printGroupDialog: false,
      goodsGroupPriceDialog: false,
      productGoodsGroupDashboard: false,
      selectedSaleList: false,
      selectedUnSaleList: false,
      selectedAll: false,
      goodsGroupCUDialog: false,
      customerListDialogTitle: 'لیست طرف معامله',
      customerList: [],
      customerDialog: false,
      selectedGroup: undefined,
      goodsStateDialog: false,
      items: [],
      itemsOptions: [],
      filter: '',
      printList: [
        {
          id: 1,
          title: 'قیمت لیست کالاهای گروه',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/قیمت لیست کالاهای یک گروه'
        },
        {
          id: 2,
          title: 'قیمت لیست کالاها به همراه موجودی کالا',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش لیست کالاهای یک گروه به همراه موجودی کالا'
        },
        {
          id: 3,
          title: 'کامل فروش از ابتدای فعالیت تاکنون',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش فروش کالاهای یک گروه از ابتدای فعالیت تاکنون'
        },
        {
          id: 4,
          title: 'لیست کالاها به همراه قیمت لیست و نقد کارتن',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/لیست کالاهای یک گروه به همراه قیمت لیست، قیمت نقد کارتن و قیمت نقد بسته'
        },
        {
          id: 5,
          title: 'لیست کالاهای موجود یک گروه به همراه قیمت لیست و نقد کارتن',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/لیست کالاهای موجود یک گروه به همراه قیمت لیست و نقد کارتن'
        },
        {
          id: 6,
          title: 'گزارش فروش ماهانه گروه کالاها در سال جاری به ازای مشتریان',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش فروش ماهانه گروه کالا به ازای مشتریان در سال جاری'
        },
        {
          id: 7,
          title: 'چاپ نقطه جوش کالاها',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات خرید/فرم نقطه جوش گروه کالا'
        },
        {
          id: 8,
          title: 'گزارش فروش 12 ماه کالاهای یک گروه در سال جاری',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش فروش 12 ماه کالاهای یک گروه کالا'
        },
        {
          id: 9,
          title: 'لیست کالاهای یک گروه به همراه قیمت لیست، قیمت نقد کارتن و قیمت نقد بسته و درصدها و خرید روز',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/لیست کالاهای یک گروه به همراه قیمت لیست، قیمت نقد کارتن و قیمت نقد بسته و درصدها و خرید روز'
        },
        {
          id: 10,
          title: 'لیسن کالاهای برگشتی گروه',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش کالاهای مرتبط با فاکتورهای برگشتی یک گروه کالا'
        },
      ],
      printGroupList: [
        {
          id: 1,
          title: 'گزارش فروش ماهانه گروه کالایی از ابتدای فعالیت تاکنون',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش ماهیانه فروش گروه کالا'
        },
        {
          id: 2,
          title: 'گزارش فروش ماهانه گروه کالاها در سال جاری',
          url: 'https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش فروش ماهانه گروه کالا در سال جاری'
        },
      ],
      pagination: {
        rowsPerPage: 50
      },
      columns: [
        {
          name: 'Group_Name',
          required: true,
          label: 'عنوان گروه',
          align: 'center',
          field: row => row.Group_Name,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Stock',
          required: true,
          label: 'موجودی',
          align: 'center',
          field: row => row.Goods_Stock,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Goods_Type',
          required: true,
          label: 'نوع فروش',
          align: 'center',
          field: row => row.Goods_Stock,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'DiffPay',
          required: true,
          label: 'اختلاف خرید و فروش',
          align: 'center',
          field: row => row.DiffPay,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {
          name: 'Profit',
          required: true,
          label: 'سود(٪)',
          align: 'center',
          field: row => row.Profit,
          format: val => `${(val ? val : '')}`,
          sortable: true
        },
        {}
      ],
    }
  },
  methods: {
    ...mapActions({
      getList: 'Products/getGoodsGroup',
      getCustomerList: 'Products/getCustomerRelation',
      addGroup: 'Products/addGoodsGroup'
    }),
    showGroupPrintDialog() {
      this.printGroupDialog = true
    },
    showPrintDialog(rowInfo) {
      this.selectedGroup = rowInfo
      this.printDialog = true
    },
    async loadReport(args) {
      await this.openURL(`${args.url}?rs:Format=PDF&GroupCode=${this.selectedGroup.Group_ID}&GroupName=${this.selectedGroup.Group_Name}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    async loadGroupReport(args) {
      await this.openURL(`${args.url}?rs:Format=PDF&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showGoodsGroupPrice(rowInfo) {
      this.selectedGroup = rowInfo
      this.goodsGroupPriceDialog = true
    },
    showGoodsGroupDashBoard(rowInfo) {
      this.selectedGroup = rowInfo
      this.productGoodsGroupDashboard = true
    },
    selectedSaleGoods() {
      this.items = this.items.filter(item => item.Goods_Group)
    },
    deleteGoodsGroup(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'گروه کالا حذف شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        const index = this.items.findIndex(item => {
          return (row.Group_ID === item.Group_ID)
        })
        this.$delete(this.items, index)
      })
    },
    changedGoodsGroup(args) {
      if (args.Group_ID === undefined) {
        this.addGroup(args).then((res) => {
          this.items.push(res)
          this.$q.notify({
            message: 'گروه کالا اضافه شد',
            type: 'positive',
            color: 'positive',
            icon: 'positive',
            position: 'top'
          })
        })
        this.goodsGroupCUDialog = false
      } else {
        this.addGroup(args).then((res) => {
          this.items.push(res)
          const index = this.items.findIndex(item => {
            return (args.Group_ID === item.Group_ID)
          })
          this.items.splice(index, 1, args)
          this.goodsGroupCUDialog = false
          this.$q.notify({
            message: 'عنوان گروه ویرایش گردید',
            type: 'positive',
            color: 'positive',
            icon: 'positive',
            position: 'top'
          })
        })
      }
    },
    showGoodsGroupCuDialog(args) {
      this.selectedGroup = args
      this.goodsGroupCUDialog = true
    },
    changedGoodsState() {
      this.$emit('group-selected', this.selectedGroup)
      this.goodsStateDialog = false
    },
    showGoodsStateDialog(row) {
      this.selectedGroup = row
      this.goodsStateDialog = true
    },
    setList() {
      if (this.customerInfo || this.customerInfo !== undefined) {
        this.getList(this.customerInfo).then((res) => {
          this.items = this.lodash.orderBy(res, ['Goods_Stock'], ['desc'])
          this.itemsOptions = this.items
        })
      } else {
        this.getList({}).then((res) => {
          this.items = this.lodash.orderBy(res, ['Goods_Stock'], ['desc'])
          this.itemsOptions = this.items
        })
      }
    },
    showCustomerNoWorking(row) {
      this.selectedGroup = row;
      this.customerListDialogTitle = `لیست طرف معامله‌ که گروه کالای ${row.Group_Name} را تاکنون نخریده اند `
      this.getCustomerList({
        groupIds: row.Group_ID,
        flag: 0
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
    showCustomerWorking(row) {
      this.selectedGroup = row;
      this.customerListDialogTitle = `لیست طرف معامله که گروه کالای ${row.Group_Name} را تاکنون خریده اند `
      this.getCustomerList({
        groupIds: row.Group_ID,
        flag: 1
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
  },
  watch: {
    selectedSaleList: function (vale) {
      if (vale) {
        this.selectedUnSaleList = false
        this.selectedAll = false
        this.items = this.itemsOptions.filter(item => item.Goods_Group)
      }
    },
    selectedUnSaleList: function (vale) {
      if (vale) {
        this.selectedSaleList = false
        this.selectedAll = false
        this.items = this.itemsOptions.filter(item => !item.Goods_Group)
      }
    },
    selectedAll: function (vale) {
      if (vale) {
        this.selectedUnSaleList = false
        this.selectedSaleList = false
        this.items = this.itemsOptions
      }
    }
  },
  created() {
    this.setList()
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>